<template>
  <component
    :is="level"
    class="header-text-component"
    :class="[sizeClass, weightClass]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'HeaderText',
  props: {
    level: {
      type: String,
      default: 'h2',
    },
    size: {
      type: String,
      default: 'md',
    },
    weight: {
      type: String,
      default: 'semi',
    },
  },
  computed: {
    sizeClass() {
      return `size-${this.size}`;
    },
    weightClass() {
      return `weight-${this.weight}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-text-component {
  margin: 0;

  &.size-xxs {
    font-size: rem-calc(18);
    line-height: rem-calc(24);
  }

  &.size-xs {
    font-size: rem-calc(20);
    line-height: rem-calc(28);
  }

  &.size-sm {
    font-size: rem-calc(24);
    line-height: rem-calc(32);
  }

  &.size-md {
    font-size: rem-calc(28);
    line-height: rem-calc(36);
  }

  &.size-lg {
    font-size: rem-calc(32);
    line-height: rem-calc(40);
  }

  &.size-xl {
    font-size: rem-calc(36);
    line-height: rem-calc(44);
  }

  &.size-xxl {
    font-size: rem-calc(40);
    line-height: rem-calc(52);
  }

  &.weight-semi {
    font-weight: $semi-bold;
  }

  &.weight-bold {
    font-weight: $bold;
  }
}
</style>
